<template>
  <v-card>
    <v-card-title class="px-0">
      <v-spacer></v-spacer>
      <v-btn
        v-if="currentUser.role !== 'manager'"
        color="primary"
        class="mr-0"
        @click="openModalCreateQuestion"
      >
        Add personal question
      </v-btn>
    </v-card-title>
    <v-layout column>
      <v-flex style="overflow: auto">
        <v-layout row wrap v-for="(question, index) in questionList" :key="question.id">
            <v-flex xs12 sm1>
              <p class="v-label v-label--active" style="font-size:12px;margin-top:5px;">Active</p>
              <v-switch
                v-model="question.selected"
                color="success"
                :disabled="round.status"
                @change="associatePersonalQuestion(question)"
              ></v-switch>
            </v-flex>
            <v-flex xs12 sm7>
              <v-text-field
                label="Title"
                v-model="question.title"
                disabled
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 v-if="question.selected">
              <v-text-field
                v-model="question.order"
                label="Order"
                @input="updateOrderPersonalQuestion(question)"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 v-if="question.selected">
              <p class="v-label v-label--active" style="font-size:12px;margin-top:5px;">Required</p>
                <v-switch
                  color="success"
                  v-model="question.required"
                  @change="updateRequiredPersonalQuestion(question)"
                ></v-switch>
            </v-flex>
          </v-layout>
         
      </v-flex>
    </v-layout>
    <modal-create-personal-question
      :show-modal="showModal.createQuestion"
      :round-id="round.id"
      @close-modal-create="showModal.createQuestion = false"
      @add-personal-question="addQuestion"
    ></modal-create-personal-question>
    
  </v-card>
</template>
<script>
import ModalCreatePersonalQuestion from '@/components/client/questions/modals/CreatePersonalQuestion.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    ModalCreatePersonalQuestion,
  },
  props: {
    round: {
      type: Object,
      required: true
    }
  },
  
  data () {
    return {
      questionList: [],
      showModal: {
        createQuestion: false,
      },
      selectedQuestion: null,
      offsetTop: 0,
      selected: [],
    };
  },
  computed: {
    ...mapGetters('question', ['questions', 'question']),
    ...mapGetters(['currentUser']),
    copyListQuestions: function () {
      if (this.round.status === true) {
        return this.selected;
      }
      return this.questionList;
    }
  },
  mounted () {
    this.loadPersonalQuestions();
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    loadPersonalQuestions () {
      let _self = this;
      let url = 'questions/type/PERSONAL';
      window.axios.get(url).then((response) => {
        for (let index = 0; index < response.data.data.length; index++) {
          response.data.data[index].selected = false;
        }
        this.questionList = response.data.data;
        this.loadPersonalQuestionsRound();
      });
    },
    loadPersonalQuestionsRound () {
      let _self = this;
      let url = `rounds/${this.round.id}/personal-questions`;
      window.axios.get(url).then((response) => {
        for (let index = 0; index < response.data.data.length; index++) {
          let indexOfEdit = this.questionList.map((e) => { 
            return e.id; 
          }).indexOf(response.data.data[index].id);
          this.questionList[indexOfEdit].selected = true;
          this.questionList[indexOfEdit].required = response.data.data[index].required;
          this.questionList[indexOfEdit].order = response.data.data[index].order;
          this.sortByKey(this.questionList, 'selected');
        }
      });
    },
    associatePersonalQuestion (question) {
      const url = `rounds/${this.round.id}/associate-personal-question`;
      const payload = {
        question: question,
      };
      window.axios.put(url, payload).then(response => {
        this.sortByKey(this.questionList, 'selected');
        this.setSnackbar({
          show: true,
          color: 'green',
          text: 'Personal questions associated'
        });
      });
    },
    updateRequiredPersonalQuestion (question) {
      const url = `rounds/${this.round.id}/update-required-question`;
      const payload = {
        question: question,
      };
      window.axios.put(url, payload).then(response => {
        this.setSnackbar({
          show: true,
          color: 'green',
          text: 'Personal questions associated'
        });
      });
    },
    openModalCreateQuestion () {
      this.showModal.createQuestion = true;
    },
    addQuestion (value) {
      this.questionList.push(value);
    },
    updateOrderPersonalQuestion (question) {
      const url = `rounds/${this.round.id}/update-order-personal-question`;
      const payload = {
        question: question,
      };
      window.axios.put(url, payload).then(response => { });
    },
    onScroll (e) {
      this.offsetTop = e.target.scrollTop;
    },
    sortByKey (array, key) {
      return array.sort(function (a, b) {
        let x = a[key]; let y = b[key];
        return ((x > y) ? -1 : ((x < y) ? 1 : 0));
      });
    }
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/PersonalQuestions.vue